import React, { useState } from "react";
import "./invoices-client.scss";
import Button from "@material-ui/core/Button";
import { Redirect } from "react-router";
import CreateInvoiceClient from "./components/create-invoice-client";
import LoopIcon from '@material-ui/icons/Loop';
import {Tooltip} from "@material-ui/core";

const InvoicesClient = (props) => {
  const { invoices, child } = props;
  const [invoiceId, setInvoiceId] = useState(null);
  const [open, setOpen] = useState(false);

  const paidContainer = {
    backgroundColor: "#F8FFF4",
    border: "1px solid #81CC5E",
  };

  const statusInvoice = (id) => {
    const paid = {
      color: "#81CC5E",
    };
    const unpaid = {
      color: "#F14343",
    };
    if (id === 2) {
      return paid;
    } else return unpaid;
  };

  const openCreateInvoice = () => {
    setOpen(!open);
  };

  if (invoiceId !== null) {
    return <Redirect to={`/client/invoice/${invoiceId}`} />;
  }

  return (
    <div className="invoicesClientWrapper">
      <Button onClick={openCreateInvoice}>Приобрести занятия</Button>
      <div className="invoicesClientContent">
        {invoices.map((item) => (
          <div
            className="invoicesClientContainer"
            key={item.id}
            style={item.state.id === 2 ? paidContainer : null}
            onClick={() => setInvoiceId(item.id)}
          >
            <div className="invoicesClientHeader">
              <div className="invoicesHeaderLesson">
                <h3>
                  Занятия:{" "}
                  <label style={statusInvoice(item.state.id)}>
                    {item.count} {item.is_refundable ? <Tooltip title="Возвратный абонемент">
                      <LoopIcon className="invoicesHeaderLesson--loop-icon"/>
                  </Tooltip> : null}
                  </label>
                </h3>
                <span>{item.month}</span>
              </div>
              <div
                className="invoicesHeaderPay"
                style={statusInvoice(item.state.id)}
              >
                <label>{item.price} р.</label>
                <span>{item.state.description}</span>
              </div>
            </div>
            <div className="invoicesFooter">
              <div className="invoicesFooterFilial">
                <span className="filial">
                  Филиал:{" "}
                  <span>{item.training[0]?.schedule?.filial?.name}</span>
                </span>
                <span className="group">
                  Группа: <span>{item.training[0]?.schedule.group.name}</span>
                </span>
              </div>
              <div className="invoicesFooterDate">
                <span>{item.created_at}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      {open && (
        <CreateInvoiceClient open={open} close={setOpen} child={child} />
      )}
    </div>
  );
};

export default InvoicesClient;
